import React from 'react';
import TemplatesList from 'app-js/components/TemplatesList';

const HomePage = () => {
	return <TemplatesList />;
};

export default HomePage;



// WEBPACK FOOTER //
// ./src/public/js/view/pages/HomePage.js